module.exports = __webpack_public_path__ + "img/map2_seoul_yeok.ab83365b.jpg";